import AppLogo from '@Framework/assets/logo.svg';
export default () => ({
    appName: 'Pomysły pracownicze',
    appLogo: AppLogo
});
